import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API_ROOT = `${BASE}/api`;

export const api = axios.create({
  baseURL: API_ROOT,
  timeout: 30000,
});

export const setAuthToken = (token) => {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
    localStorage.setItem("operon_token", token);
  } else {
    delete api.defaults.headers.common.Authorization;
    localStorage.removeItem("operon_token");
  }
};

export const loadStoredToken = () => {
  const t = localStorage.getItem("operon_token");
  if (t) api.defaults.headers.common.Authorization = `Bearer ${t}`;
  return t;
};

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // Global 401 handler: token has expired or been revoked → clear it so
    // ProtectedRoute will route to /login on the next render. Components can
    // still catch the error and show their own toasts.
    const status = err?.response?.status;
    if (status === 401) {
      try {
        delete api.defaults.headers.common.Authorization;
        localStorage.removeItem("operon_token");
        // Fire a custom event so AuthProvider can react and clear its state
        window.dispatchEvent(new CustomEvent("operon:auth:logout"));
      } catch (_) { /* no-op */ }
    }
    return Promise.reject(err);
  }
);

export const extractErr = (err, fallback = "Something went wrong") => {
  if (!err) return fallback;
  const d = err?.response?.data;
  if (!d) return err.message || fallback;
  if (typeof d === "string") return d;
  if (d.detail) {
    if (typeof d.detail === "string") return d.detail;
    if (d.detail.message) return d.detail.message;
    if (Array.isArray(d.detail)) return d.detail.map((x) => x.msg || JSON.stringify(x)).join("; ");
    return JSON.stringify(d.detail);
  }
  return d.message || fallback;
};
